export default {"src":"/assessments/student/_next/static/media/logo-ww.6eebf6a7.svg","height":28,"width":79,"blurWidth":0,"blurHeight":0};